/**
 * 时间处理工具
 */
;
(function(win, UpAct) {
    const TimeUtil = {
        /**
         * 获取活动时间
         * @param startTime 活动开始时间
         * @param endTime 活动结束时间
         * @param lang 语言
         * @param separator 分隔符
         */
        getActTimeWithDate(startTime, endTime, lang, separator) {
            let st, et;

            lang = lang.replace('-', '').toLowerCase();
            separator = (typeof separator == 'undefined') ? ' ～ ' : separator;

            let sdateObj = new Date(startTime);
            let edateObj = new Date(endTime);
            let syear = sdateObj.getFullYear();
            let eyear = edateObj.getFullYear();

            if (lang == 'areg') {
                st = this.formatDate(startTime, 'dd/MM/yyyy HH:mm', 12);
                et = this.formatDate(endTime, 'dd/MM/yyyy HH:mm', 12);
                return st + separator + et;
            } else if (lang == 'vivn') {
                st = this.formatDate(startTime, 'HH:mm dd.MM.yyyy');
                et = this.formatDate(endTime, 'HH:mm dd.MM.yyyy');
                return st + separator + et;
            } else {
                st = this.formatDate(startTime, 'yyyy/MM/dd HH:mm');

                if (syear == eyear) {
                    et = this.formatDate(endTime, 'MM/dd HH:mm');
                } else {
                    et = this.formatDate(endTime, 'yyyy/MM/dd HH:mm');
                }

                return st + separator + et;
            }
        },
        /**
         * 获取日榜时间
         * @param startTime 活动开始时间
         * @param endTime 活动结束时间
         * @param lang 语言
         * @param separator 分隔符
         */
        getDailyTimeWithDate(startTime, endTime, lang, separator) {
            let st, et;

            lang = lang.replace('-', '').toLowerCase();
            separator = (typeof separator == 'undefined') ? ' ～ ' : separator;

            if (lang == 'areg') {
                st = this.formatDate(startTime, 'dd/MM HH:mm:ss', 12);
                et = this.formatDate(endTime, 'dd/MM HH:mm:ss', 12);
                return st + separator + et;
            } else if (lang == 'vivn') {
                st = this.formatDate(startTime, 'HH:mm:ss dd.MM.yyyy');
                et = this.formatDate(endTime, 'HH:mm:ss dd.MM.yyyy');
                return st + separator + et;
            } else {
                st = this.formatDate(startTime, 'MM/dd HH:mm:ss');
                et = this.formatDate(endTime, 'MM/dd HH:mm:ss');
                return st + separator + et;
            }
        },
        /** 
         * 格式化时间
         * @param time  时间。1. 时间戳：1407897620000；2: 字符串：2014/12/12 12:00:00
         *        new Date(1407897620000)、new Date()、new Date('2014/12/12 12:00:00')
         * @param pattern {String} 格式化模板（默认："yyyy-MM-dd HH:mm:ss"）
         * @param hourType {number} 小时制。12小时、24小时。默认24小时制
         * @return {String} 格式化后的文本 
         **/
        formatDate: function(time, pattern, hourType) {
            var dateObj = new Date(time);

            hourType = hourType || 24;

            if (!pattern) {
                pattern = "yyyy-MM-dd HH:mm:ss";
            }
            var val, result, hour, minute, second;
            var func = function(matched) {
                return matched.length == 2 && val < 10 ? ("0" + val) : val;
            };

            result = pattern.replace(/y{2,4}/, dateObj.getFullYear()); // the year
            val = dateObj.getMonth() + 1; // the month
            result = result.replace(/M{1,2}/, func);
            val = dateObj.getDate(); // the date
            result = result.replace(/d{1,2}/, func);

            if (hourType == 12) {
                val = hour = dateObj.getHours(); // the hour

                let isAm = 1;

                if (val > 12) {
                    result = result.replace(/H{1,2}/, function(matched) {
                        if (matched.length == 2) {
                            if (val > 12) {
                                val = val - 12;
                                if (val < 10) {
                                    val = '0' + val;
                                }
                                isAm = 0;
                            } else if (val < 10) {
                                val = '0' + val;
                                isAm = 1;
                            }
                        }
                        return val;
                    });
                    val = minute = dateObj.getMinutes(); // the minute
                    result = result.replace(/m{1,2}/, func);
                    val = second = dateObj.getSeconds(); // the second
                    result = result.replace(/s{1,2}/, func);
                } else {
                    result = result.replace(/H{1,2}/, func);
                    val = minute = dateObj.getMinutes(); // the minute
                    result = result.replace(/m{1,2}/, func);
                    val = second = dateObj.getSeconds(); // the second
                    result = result.replace(/s{1,2}/, func);
                }

                if (isAm) {
                    if (hour == 0 && minute == 0 && second == 0) {
                        dateObj = new Date(time);
                        result = pattern.replace(/y{2,4}/, dateObj.getFullYear()); // the year
                        val = dateObj.getMonth() + 1; // the month
                        result = result.replace(/M{1,2}/, func);
                        val = dateObj.getDate(); // the date
                        result = result.replace(/d{1,2}/, func);
                        val = hour = 12;
                        result = result.replace(/H{1,2}/, func);
                        val = minute = 0; // the minute
                        result = result.replace(/m{1,2}/, func);
                        val = 0; // the second
                        result = result.replace(/s{1,2}/, func);
                        result += 'am';
                    } else {
                        result += 'am';
                    }
                } else {
                    result += 'pm';
                }
            } else {
                val = hour = dateObj.getHours(); // the hour
                result = result.replace(/H{1,2}/, func);
                val = minute = dateObj.getMinutes(); // the minute
                result = result.replace(/m{1,2}/, func);
                val = second = dateObj.getSeconds(); // the second
                result = result.replace(/s{1,2}/, func);
            }

            return result;
        },


        build: function(time) {
            var builtTime;

            switch (typeof(time)) {
                case 'number':
                    builtTime = new Date(parseInt(time));
                    break;
                case 'string':
                    // ios下，时间格式为2012-12-12会报错，解决方案: 2012-12-12 ==> 2012/12/12
                    builtTime = Number(time) ? arguments.callee(parseInt(time)) : new Date(time.replace(/-/g, '/'));
                    break;
                default:
                    builtTime = time instanceof Date ? time : new Date();
            }

            if (builtTime == 'Invalid Date') {
                throw new Error('[TimeFormater]: Invalid Date!');
            }

            return builtTime;
        }
    }

    UpAct.TimeUtil = TimeUtil;

})(window, window['UpAct'] || (window['UpAct'] = {}));


// WEBPACK FOOTER //
// ./js/lib/util/date.js